var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEventReportIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3V2H15.5V3H8.5V2H7.5V3H4.5V22H19.5V3H16.5ZM5.5 21V4H7.5V5H8.5V4H15.5V5H16.5V4H18.5V21H5.5ZM7.5 18V19H16.5V18H7.5ZM16.5 16V17H7.5V16H16.5ZM12 14C14.205 14 16 12.205 16 10C16 7.795 14.205 6 12 6C9.795 6 8 7.795 8 10C8 12.205 9.795 14 12 14ZM12 7C13.655 7 15 8.345 15 10C15 11.655 13.655 13 12 13C10.345 13 9 11.655 9 10C9 8.345 10.345 7 12 7ZM11.5 9.5V8H12.5V10.5H10V9.5H11.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEventReportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Event_Report_icon.5835829671d85081e7cb5df604a9394d.svg";